import { Component } from '@angular/core';

import { AppHeaderService } from 'src/app/services/app-header/app-header.service';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false,
})
export class TopBarComponent {
  constructor(
    public appHeader: AppHeaderService,
  ) {}
}
